module.exports = __webpack_public_path__ + "img/ver5.93465561.jpg";